import { IconError } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import React from 'react';
import { useIntl } from 'react-intl';
import { StyledErrorWrapper, StyledNodeWrapper } from './styles';

type BaseNodeProps = {
  children: React.ReactNode;
  type: 'action' | 'sensor';
  isValid?: boolean;
  selected?: boolean;
  disabled?: boolean;
  testId?: string;
};

function BaseNode({
  children,
  type,
  isValid,
  selected,
  disabled,
  testId,
}: BaseNodeProps) {
  const intl = useIntl();
  return (
    <StyledNodeWrapper
      selected={selected ?? false}
      type={type}
      disabled={disabled}
      data-testid={testId ?? 'base-node'}
    >
      {!isValid && (
        <StyledErrorWrapper>
          <Flex direction="column" align="center">
            <T body2 color="#DB0000">
              {intl.formatMessage({
                defaultMessage: 'Invalid Values',
                id: 'Xyu4KQ',
              })}
            </T>
            <IconError />
          </Flex>
        </StyledErrorWrapper>
      )}
      {children}
    </StyledNodeWrapper>
  );
}

export default BaseNode;
